import {
  WEB_MARKETING_ADCASH_CTA_URL,
  WEB_MARKETING_LIVE_PREVIEW_DURATION,
  WEB_MARKETING_US_TRIAL_FLAG,
  WEB_MARKETING_LATINO_TRIAL_FLAG,
  WEB_MARKETING_CANADA_TRIAL_FLAG,
  WEB_MARKETING_CA_VALUE_PROPS,
  WEB_MARKETING_NHL_COUNTDOWN_TIMER,
  WEB_MARKETING_NBA_COUNTDOWN_TIMER,
  WEB_MARKETING_PPV_UEFA_WCQ,
  WEB_MARKETING_INTERNATIONAL_FRIENDLY_SCHEDULER,
  WEB_MARKETING_HERO_IMAGE,
  WEB_MARKETING_HEADER_SIGN_IN,
  WEB_MARKETING_PPV_INTEGRATED_SPORTS,
} from './constants'

import type { BooleanValueFlag, Flag, StringValueFlag } from './types'

type MarketingAdcashCtaUrl = typeof WEB_MARKETING_ADCASH_CTA_URL
type MarketingLivePreviewDuration = typeof WEB_MARKETING_LIVE_PREVIEW_DURATION
type MarketingUsTrialFlag = typeof WEB_MARKETING_US_TRIAL_FLAG
type MarketingLatinoTrialFlag = typeof WEB_MARKETING_LATINO_TRIAL_FLAG
type MarketingCanadaTrialFlag = typeof WEB_MARKETING_CANADA_TRIAL_FLAG
type MarketingCaValueProps = typeof WEB_MARKETING_CA_VALUE_PROPS
type MarketingNhlCountdownTimer = typeof WEB_MARKETING_NHL_COUNTDOWN_TIMER
type MarketingNbaCountdownTimer = typeof WEB_MARKETING_NBA_COUNTDOWN_TIMER
type MarketingPpvUefaWcq = typeof WEB_MARKETING_PPV_UEFA_WCQ
type MarketingInternationalFriendlyScheduler = typeof WEB_MARKETING_INTERNATIONAL_FRIENDLY_SCHEDULER
type MarketingHeroImage = typeof WEB_MARKETING_HERO_IMAGE
type MarketingHeaderSignIn = typeof WEB_MARKETING_HEADER_SIGN_IN
type MarketingPpvIntegratedSports = typeof WEB_MARKETING_PPV_INTEGRATED_SPORTS
function flag<K extends string, V>(key: K, value: V, ttl = -1): Flag<K, V> {
  return {
    key,
    value,
    ttl,
  }
}

// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function booleanFlag<K extends string>(key: K, value = false, ttl = -1): BooleanValueFlag<K> {
  return flag<K, boolean>(key, value, ttl)
}
function stringFlag<K extends string>(key: K, value = 'default', ttl = -1): StringValueFlag<K> {
  return flag<K, string>(key, value, ttl)
}

export const initValues = {
  [WEB_MARKETING_ADCASH_CTA_URL]: stringFlag<MarketingAdcashCtaUrl>(WEB_MARKETING_ADCASH_CTA_URL),
  [WEB_MARKETING_LIVE_PREVIEW_DURATION]: stringFlag<MarketingLivePreviewDuration>(
    WEB_MARKETING_LIVE_PREVIEW_DURATION
  ),

  [WEB_MARKETING_US_TRIAL_FLAG]: booleanFlag<MarketingUsTrialFlag>(WEB_MARKETING_US_TRIAL_FLAG),
  [WEB_MARKETING_LATINO_TRIAL_FLAG]: booleanFlag<MarketingLatinoTrialFlag>(
    WEB_MARKETING_LATINO_TRIAL_FLAG
  ),
  [WEB_MARKETING_CANADA_TRIAL_FLAG]: booleanFlag<MarketingCanadaTrialFlag>(
    WEB_MARKETING_CANADA_TRIAL_FLAG
  ),
  [WEB_MARKETING_CA_VALUE_PROPS]: stringFlag<MarketingCaValueProps>(WEB_MARKETING_CA_VALUE_PROPS),
  [WEB_MARKETING_NHL_COUNTDOWN_TIMER]: stringFlag<MarketingNhlCountdownTimer>(
    WEB_MARKETING_NHL_COUNTDOWN_TIMER
  ),
  [WEB_MARKETING_NBA_COUNTDOWN_TIMER]: stringFlag<MarketingNbaCountdownTimer>(
    WEB_MARKETING_NBA_COUNTDOWN_TIMER
  ),
  [WEB_MARKETING_PPV_UEFA_WCQ]: stringFlag<MarketingPpvUefaWcq>(WEB_MARKETING_PPV_UEFA_WCQ),
  [WEB_MARKETING_INTERNATIONAL_FRIENDLY_SCHEDULER]:
    stringFlag<MarketingInternationalFriendlyScheduler>(
      WEB_MARKETING_INTERNATIONAL_FRIENDLY_SCHEDULER
    ),
  [WEB_MARKETING_HERO_IMAGE]: stringFlag<MarketingHeroImage>(WEB_MARKETING_HERO_IMAGE),
  [WEB_MARKETING_HEADER_SIGN_IN]: stringFlag<MarketingHeaderSignIn>(WEB_MARKETING_HEADER_SIGN_IN),
  [WEB_MARKETING_PPV_INTEGRATED_SPORTS]: booleanFlag<MarketingPpvIntegratedSports>(
    WEB_MARKETING_PPV_INTEGRATED_SPORTS
  ),
} as const

export type StacFlags = typeof initValues
export type StacFlagKey = keyof StacFlags
export type StacFlagKeys = StacFlagKey[]

export const supportedFlags = Object.keys(initValues) as StacFlagKeys
